import styled from 'styled-components';

export const AccountsWrapper = styled.div`
  /* The page itself must not grow past the viewport, otherwise .content (display:flex; flex:1 in
     main.styled.js) just gets taller and nothing scrolls - same arrangement as FormWrapper. */
  max-height: 100vh;
  overflow: hidden;

  .list-header,
  .list-row {
    display: grid;
    grid-template-columns: 2fr 3fr 1.2fr 170px;
    align-items: center;
    column-gap: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  }

  .list-header {
    color: ${({ theme }) => theme.colors.LighterText};
    /* Opaque, not backgroundColor_05: rows scroll underneath a sticky header. */
    background: ${({ theme }) => theme.colors.ZenLightGray};
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .list-row:hover {
    background: ${({ theme }) => theme.colors.hoverColor};
  }

  .muted {
    color: ${({ theme }) => theme.colors.LighterText};
  }

  .current-account {
    background: ${({ theme }) => theme.colors.ZenDefaultSecondary_O3};
  }

  .masquerading-banner {
    background: ${({ theme }) => theme.colors.ZenPurpleSecondary2};
    color: ${({ theme }) => theme.colors.zenPurple};
    border: 1px solid ${({ theme }) => theme.colors.ZenPurpleSecondary};
    border-radius: 6px;
  }

  .no-permission {
    color: ${({ theme }) => theme.colors.LighterText};
  }
`;
